import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback, useMemo } from 'react';
import { useDeviceConfig } from 'console/shared/contexts/device/config';
import { useDeviceState } from 'console/shared/contexts/device/state';
import { CustomControlButton } from './button';
import { CustomControlSlider } from './slider';
import { useCustomControl } from '../../provider';
import { WebElement } from 'z3k-config';
import { noop } from 'ts-essentials';
import { useAction } from 'shared/hooks/redux/hooks';
export const CustomControlElement = memo(function CustomControlElement() {
    const { online } = useDeviceState();
    const { device_id } = useDeviceConfig();
    const { type, state_value, sendCustomCommand, is_active } = useCustomControl();
    const onSendCustomCommand = sendCustomCommand
        ? useAction(sendCustomCommand)
        : undefined;
    const complex_button_value = useMemo(() => (is_active ? 0 : 1), [is_active]);
    const onSendCommand = useCallback((analog_value) => {
        if (onSendCustomCommand) {
            return onSendCustomCommand(analog_value !== undefined && analog_value !== null
                ? analog_value
                : complex_button_value);
        }
        return noop();
    }, [onSendCustomCommand, device_id, complex_button_value]);
    if (type === WebElement.Type.ANALOG) {
        return (_jsx(CustomControlSlider, { state_value: state_value, onSendCommand: onSendCommand, online: online }));
    }
    return _jsx(CustomControlButton, { online: online, onSendCommand: onSendCommand });
});
